import { useMemo } from 'react';

import type { SetupCatalogSummary } from '@/components/setup/experience/lib/setupCatalogSummary';
import { buildSetupCatalogSummary, buildSetupProductsListInput } from '@/components/setup/experience/lib/setupCatalogSummary';
import { useProductsList } from '@/lib/api/products';

export function useSetupCatalogSummary(storeId: string | undefined, currency: string, enabled: boolean) {
  const { data, isLoading, isFetching } = useProductsList(buildSetupProductsListInput(storeId ?? ''), {
    enabled: Boolean(storeId && enabled),
    refetchOnMount: 'always',
  });

  const summary = useMemo(
    () => buildSetupCatalogSummary(data?.items, currency),
    [currency, data?.items],
  );

  return { summary, products: data?.items, isLoading: isLoading || isFetching };
}
